// Shared inline styles for the 5 v2 auth pages — CHG-1277 / ITER-3402.
//
// Kept as inline-style objects rather than CSS modules to match the
// _dev/auth-preview.tsx precedent (CHG-1271) — same minimal-dependency
// approach used by the brand-aware shell.

import type { CSSProperties } from "react";

export const inputStyle: CSSProperties = {
  width: "100%",
  padding: "8px 10px",
  marginTop: 4,
  fontSize: 14,
  border: "1px solid var(--color-border)",
  borderRadius: "var(--radius-sm, 6px)",
  background: "var(--color-bg-subtle)",
  color: "var(--color-text)",
  boxSizing: "border-box",
};

export const labelStyle: CSSProperties = {
  display: "block",
  fontSize: 13,
  fontWeight: 500,
  marginBottom: 4,
};

export const errorStyle: CSSProperties = {
  marginTop: 12,
  padding: "8px 10px",
  fontSize: 13,
  color: "var(--color-danger, #b91c1c)",
  background: "var(--color-danger-bg, #fef2f2)",
  borderRadius: "var(--radius-sm, 6px)",
};

export const successHintStyle: CSSProperties = {
  fontSize: 14,
  color: "var(--color-text)",
  textAlign: "center",
};

export function submitStyle(busy: boolean): CSSProperties {
  return {
    marginTop: 16,
    width: "100%",
    padding: "10px 16px",
    fontSize: 14,
    fontWeight: 500,
    border: "none",
    borderRadius: "var(--radius-md, 8px)",
    background: "var(--color-primary)",
    color: "var(--color-on-primary, #fff)",
    cursor: busy ? "not-allowed" : "pointer",
    opacity: busy ? 0.6 : 1,
  };
}

export function ctaLinkStyle(): CSSProperties {
  return {
    display: "block",
    textAlign: "center",
    padding: "10px 16px",
    borderRadius: "var(--radius-md, 8px)",
    background: "var(--color-primary)",
    color: "var(--color-on-primary, #fff)",
    textDecoration: "none",
    fontWeight: 500,
  };
}
